<template>
  <div class="card">
    <div class="bg-blue-light px-1 rounded pb-2">
      <TitleButton
          class="mt-1"
          btnTitle="List"
          :showBtn="true"
          :showAddNew="false"
          :title="headerTitle"
          @onClickCloseButton="navigateToListPage"
      />
    </div>
    <div class="px-2 mt-1">
      <div class="card card-height">
        <div class="row mt-2 gy-1">
          <div class="row mt-1">
            <div v-if="isCreate" class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Asset Qty</label>
              <input
                  class="form-control"
                  tabindex="1"
                  type="text"
                  v-model="formData.asset_qty"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Asset Class</label>
              <AsyncSelect
                  placeholder="Select Asset Class"
                  v-model="formData.product_id"
                  :api-service="fetchProductList"
                  :format-label="option => option.text"
                  label="text"
                  :disabled="isPendingAssetRegister || isStockRegisterData"
                  :additional-query="{ product_type: 'fixed_assets', with_depreciation_rate: 1 }"
              />
            </div>
            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Asset Name</label>
              <input
                  class="form-control"
                  tabindex="1"
                  type="text"
                  placeholder=""
                  v-model="formData.name"
              >
            </div>
            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Asset Value</label>
              <input
                  class="form-control"
                  tabindex="1"
                  type="text"
                  placeholder=""
                  v-model="formData.asset_value"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Assign Location</label>
              <AsyncSelect
                  placeholder="Select Assign Location"
                  v-model="formData.business_location_id"
                  :api-service="fetchBusinessLocationsList"
                  label="text"
                  :format-label="option => option.text"
                  :additional-query="{ location_type: 'fixed_assets' }"
              />
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Assign Custodian</label>
              <AsyncSelect
                  placeholder="Assign Custodian"
                  v-model="formData.contact_profile_id"
                  :api-service="fetchContactProfiles"
                  :format-label="formatPatientLabel"
                  class="flex-grow-1"
                  :additional-query="{type: 'employee'}"
              />
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Department</label>
              <AsyncSelect
                  placeholder="Select Department"
                  v-model="formData.department_id"
                  :api-service="fetchDepartmentList"
                  :format-label="option => option.name"
                  label="name"
              />
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Project</label>
              <AsyncSelect
                  placeholder="Select Project"
                  v-model="formData.project_master_id"
                  :api-service="fetchProjects"
                  :format-label="option => option.name"
                  label="name"
              />
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Cost Centre</label>
              <v-select
                  placeholder="Select Cost Centre"
                  v-model="formData.cost_centre_id"
                  :options="costCentres"
                  :reduce="name => name.id"
                  label="name"
              />
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Business Unit</label>
              <v-select
                  placeholder="Select Business Unit"
                  v-model="formData.business_id"
                  :options="businesses"
                  :reduce="name => name.id"
                  label="name"
              />
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Machine Id</label>
              <input
                  class="form-control"
                  tabindex="1"
                  type="text"
                  v-model="formData.machine_id"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Model</label>
              <input
                  class="form-control"
                  tabindex="1"
                  type="text"
                  v-model="formData.model"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Manufacturer</label>
              <input
                  class="form-control"
                  tabindex="1"
                  type="text"
                  v-model="formData.manufacturer"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Manufacturer Date</label>
              <input
                  class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                  tabindex="1"
                  type="date"
                  placeholder=""
                  v-model="formData.manufacturing_date"
              >
            </div>
            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Capitalization Date</label>
              <input
                  class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                  tabindex="1"
                  type="date"
                  placeholder=""
                  v-model="formData.capitalization_date"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Bill Date</label>
              <input
                  class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                  tabindex="1"
                  type="date"
                  placeholder=""
                  :disabled="isPendingAssetRegister || isStockRegisterData"
                  v-model="formData.bill_date"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Bill Number</label>
              <input
                  class="form-control"
                  tabindex="1"
                  type="text"
                  placeholder=""
                  :disabled="isPendingAssetRegister || isStockRegisterData"
                  v-model="formData.bill_number"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Bill Qty</label>
              <input
                  class="form-control"
                  tabindex="1"
                  type="number"
                  placeholder=""
                  :disabled="isPendingAssetRegister || isStockRegisterData"
                  v-model="formData.bill_qty"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Select Supplier</label>
              <AsyncSelect
                  placeholder="Select Supplier"
                  v-model="formData.supplier_id"
                  :api-service="fetchContactProfiles"
                  :format-label="formatPatientLabel"
                  :disabled="isPendingAssetRegister || isStockRegisterData"
                  class="flex-grow-1"
              />
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Grant Donation</label>
              <select class="form-control" id="gender" v-model="formData.grant_donation">
                <option value=''>Select Option</option>
                <option v-for="(item, key) in grandDonation" :value="key">{{ item }}</option>
              </select>
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Grant Donation Details</label>
              <input
                  class="form-control"
                  tabindex="1"
                  type="text"
                  placeholder=""
                  v-model="formData.grant_donation_details"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Warranty Period</label>
              <input
                  class="form-control"
                  tabindex="1"
                  type="number"
                  placeholder=""
                  v-model="formData.warranty_period"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Insurance Details</label>
              <input
                  class="form-control"
                  tabindex="1"
                  type="text"
                  placeholder=""
                  v-model="formData.insurance_details"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Lease Details</label>
              <input
                  class="form-control"
                  tabindex="1"
                  type="text"
                  placeholder=""
                  v-model="formData.lease_details"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Installation Date</label>
              <input
                  class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                  tabindex="1"
                  type="date"
                  placeholder=""
                  v-model="formData.installation_date"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Asset Condition</label>
              <input
                  class="form-control"
                  tabindex="1"
                  type="text"
                  placeholder=""
                  v-model="formData.asset_condition"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Maintenance Schedule</label>
              <input
                  class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                  tabindex="1"
                  type="date"
                  placeholder=""
                  v-model="formData.maintenance_schedule"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Useful Life</label>
              <input
                  class="form-control"
                  tabindex="1"
                  type="number"
                  placeholder=""
                  v-model="formData.useful_life"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Residual Value</label>
              <input
                  class="form-control"
                  tabindex="1"
                  step="any"
                  type="number"
                  placeholder=""
                  v-model="formData.residual_value"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Depreciation Rate</label>
              <input
                  class="form-control"
                  tabindex="1"
                  type="text"
                  readonly
                  v-model="formData.depreciation_rate"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Tax Depreciation Rate</label>
              <input
                  class="form-control"
                  tabindex="1"
                  type="text"
                  readonly
                  v-model="formData.tax_depreciation_rate"
              >
            </div>

            <div v-if="!isCreate" class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="align-middle">Status</label>
              <v-select
                  placeholder="Select Status"
                  v-model="formData.status"
                  :options="status"
                  :reduce="name => name.value"
                  label="name"
              />
            </div>

            <div class="col-12 px-2">
              <div class="mb-1">
                <label class="form-label" for="description">Asset Description</label>
                <vField
                    as="textarea"
                    name="description"
                    v-model="formData.asset_description"
                    class="form-control"
                />
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="mt-2 d-flex justify-content-start justify-content-sm-center px-2 gap-1 flex-wrap pb-2">
      <hr class="hr-full-width mb-1">
      <button :disabled="saveButtonLoader || saveNewButtonLoader" @click="saveData()"
              class="btn btn-primary">
        Save
      </button>
      <button :disabled="saveButtonLoader || saveNewButtonLoader" @click="saveData(false)"
              class="btn btn-primary">Save & New
      </button>
      <button @click="navigateToListPage" class="btn btn-outline-secondary">Cancel</button>
    </div>

    <GlobalLoader/>
  </div>
</template>
<script setup>
import {computed, inject, onMounted, ref, watch} from 'vue'
import {useRoute, useRouter} from "vue-router";
import TitleButton from '@/components/atom/TitleButton'
import GlobalLoader from "@/components/atom/GlobalLoader.vue";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleContact from '@/services/modules/contact'
import {useStore} from "vuex";
import handleDepartments from "@/services/modules/procurement/organization-settings/department";
import handleAssetRegister from '@/services/modules/assetRegister/assetRegister'
import handlePurchaseAndSales from "@/services/modules/purchase";
import handleBusinessesLocations from '@/services/modules/businessesLocations'
import {useAsyncDropdownHelper} from "@/services/utils/asyncDropdownHelper";
import handleChartAccount from '@/services/modules/chartAccount'
import handleProjects from "@/services/modules/procurement/project";
import handleCostCentres from "@/services/modules/procurement/organization-settings/costCentre";
import handleCBusinesses from "@/services/modules/businesses";

const store = useStore();
const router = useRouter()
const route = useRoute()
const showError = inject('showError');
const showSuccess = inject('showSuccess')
const companyId = computed(() => {
  return route.params.companyId
})

let loader =ref(false)
let saveButtonLoader = ref(false)
let saveNewButtonLoader = ref(false)
let isCreate = ref(true)
let isPendingAssetRegister = ref(false)
let headerTitle = ref("Add Asset Register")
let contacts = ref([])
let locations = ref([])
let accountPayable = ref([])
let assetRegisterEditData = ref({})
let pendingAssetRegisterData = ref({})
const grandDonation = ref([]);
const status = ref([]);
const projects = ref([]);
const costCentres = ref([]);
const businesses = ref([]);
let isStockRegisterData = ref(false)
let assetRegisterData = {}
let formData = ref({
  company_id: companyId.value,
  status: 'active',
  stock_register_id:'',
  product_id:'',
  business_location_id:'',
  department_id:'',
  project_master_id:'',
  cost_centre_id:'',
  business_id:'',
  contact_profile_id:'',
  supplier_id:'',
  name:'',
  asset_value:'',
  machine_id:'',
  model:'',
  manufacturer:'',
  manufacturing_date:'',
  capitalization_date:'',
  bill_date:'',
  bill_number:'',
  bill_qty:'',
  asset_qty:1,
  grant_donation:'no',
  grant_donation_details:'',
  warranty_period:'',
  insurance_details:'',
  lease_details:'',
  installation_date:'',
  asset_condition:'',
  maintenance_schedule:'',
  useful_life:'',
  residual_value:'',
  depreciation_rate:'',
  tax_depreciation_rate:'',
  asset_description:'',
})

watch(() => formData.value.product_id, (product) => {
  if (!product) {
    formData.value.depreciation_rate = ''
    formData.value.tax_depreciation_rate = ''
    return
  }
  formData.value.depreciation_rate = product.depreciation_rate
  formData.value.tax_depreciation_rate = product.tax_depreciation_rate
})

function navigateToListPage() {
  let name = isPendingAssetRegister.value  ? `pending-asset-register` : `asset-register`;
  delete route.query.stockRegisterId;
  delete route.query.assetRegisterId;
  router.push({name: name, params: route.params, query: route.query});
}

const {
  fetchSinglePendingAssetRegister,
  fetchSingleAssetRegister,
  storeAssetRegister,
  updateAssetRegister
} = handleAssetRegister()
const { fetchProductList } = handlePurchaseAndSales()
const { fetchBusinessLocationsList } = handleBusinessesLocations()
const {fetchContactProfiles} = handleContact()
const { formatPatientLabel } = useAsyncDropdownHelper();
const { fetchDepartmentList } = handleDepartments()
const {fetchHome} = handleChartAccount()
const { fetchProjects } = handleProjects()
const { fetchCostCentreList } = handleCostCentres()
const { fetchBusinessList } = handleCBusinesses()

function saveData(redirect = true) {
  if (isCreate.value) {
    handleSubmit(redirect);
  }
  if (!isCreate.value) {
    handleUpdate(redirect);
  }
}

function handleSubmit(redirect) {
  setAssetRegisterData(true);
  createAP(redirect);
}

function handleUpdate(redirect) {
  setAssetRegisterData(false);
  updateAPData(redirect);
}

function setAssetRegisterData(isCreateMode) {
  if (!isCreateMode) {
    assetRegisterData.id = formData.value.id;
    assetRegisterData.status = formData.value.status;
  }
  if (isCreateMode) {
    assetRegisterData.status = 'active';
    assetRegisterData.asset_qty = formData.value.asset_qty;
    assetRegisterData.stock_register_id = formData.value.stock_register_id;
  }

  assetRegisterData.company_id = formData.value.company_id;
  assetRegisterData.product_id = getIdOrNull(formData.value.product_id);
  assetRegisterData.business_location_id = getIdOrNull(formData.value.business_location_id);
  assetRegisterData.department_id = getIdOrNull(formData.value.department_id);
  assetRegisterData.project_master_id = getIdOrNull(formData.value.project_master_id);
  assetRegisterData.cost_centre_id = formData.value.cost_centre_id;
  assetRegisterData.business_id = formData.value.business_id;
  assetRegisterData.contact_profile_id = getIdOrNull(formData.value.contact_profile_id);
  assetRegisterData.supplier_id = getIdOrNull(formData.value.supplier_id);

  const fields = [
    'name', 'asset_value', 'machine_id', 'model', 'manufacturer',
    'manufacturing_date', 'capitalization_date', 'bill_date',
    'bill_number', 'bill_qty', 'grant_donation', 'grant_donation_details',
    'warranty_period', 'insurance_details', 'lease_details',
    'installation_date', 'asset_condition', 'maintenance_schedule',
    'useful_life', 'residual_value', 'asset_description'
  ];

  fields.forEach(field => {
    assetRegisterData[field] = formData.value[field];
  });
}

function getIdOrNull(field) {
  return field && typeof field === 'object' ? field.id : null;
}

function createAP(redirect = true) {
  storeAssetRegister(assetRegisterData, getQuery())
      .then(res => {
        if (!res.status) {
          showError(res.message)
          return
        }
         showSuccess(res.message)
         if (redirect) navigateToListPage()
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        loader.value = false
      })
}

function updateAPData(redirect = true) {
  updateAssetRegister(assetRegisterData, assetRegisterData.id, getQuery())
      .then(res => {
        if (!res.status) {
          showError(res.message)
          return
        }
         showSuccess(res.message);
         if (redirect) navigateToListPage()
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        loader.value = false
      })
}

function getQuery() {
  return `?company_id=${route.params.companyId}`;
}

function setFormData() {
  headerTitle.value = "Update Asset Register";
  formData.value.id = assetRegisterEditData.value.id;
  const fieldsWithIdText = {
    product_id: 'product_name',
    business_location_id: 'business_location_name',
  };
  const fieldsWithIdName = {
    department_id: 'department_name',
    project_master_id: 'project_master_name',
    contact_profile_id: 'contact_profile_name',
    supplier_id: 'supplier_name',
  };

  for (const key in fieldsWithIdText) {
    formData.value[key] = {
      id: assetRegisterEditData.value[key],
      text: assetRegisterEditData.value[fieldsWithIdText[key]]
    };
  }

  formData.value.product_id.depreciation_rate = assetRegisterEditData.value.depreciation_rate;
  formData.value.product_id.tax_depreciation_rate = assetRegisterEditData.value.tax_depreciation_rate;

  for (const key in fieldsWithIdName) {
    formData.value[key] = {
      id: assetRegisterEditData.value[key],
      name: assetRegisterEditData.value[fieldsWithIdName[key]]
    };
  }

  const directFields = [
    'name', 'asset_value', 'machine_id', 'model', 'manufacturer', 'manufacturing_date', 'capitalization_date',
    'bill_date', 'bill_number', 'bill_qty', 'grant_donation', 'grant_donation_details', 'warranty_period', 'insurance_details',
    'lease_details', 'installation_date', 'asset_condition', 'maintenance_schedule', 'useful_life', 'residual_value',
    'depreciation_rate', 'tax_depreciation_rate',
    'asset_description', 'status', 'stock_register_id', 'cost_centre_id', 'business_id'
  ];

  directFields.forEach(field => {
    formData.value[field] = assetRegisterEditData.value[field];
  });

  if (
      assetRegisterEditData.value.stock_register_id &&
      assetRegisterEditData.value.stock_register_id !== '' &&
      assetRegisterEditData.value.stock_register_id !== undefined
  ){
    isStockRegisterData = true;
  }
}

function setPendingAssetRegisterData() {
  headerTitle.value = "Add Asset Register";
  formData.value.product_id = {
    id:pendingAssetRegisterData.value.product_id,
    text: pendingAssetRegisterData.value.product_name,
    depreciation_rate: pendingAssetRegisterData.value.depreciation_rate,
    tax_depreciation_rate: pendingAssetRegisterData.value.tax_depreciation_rate
  }
  formData.value.stock_register_id = pendingAssetRegisterData.value.id
  formData.value.bill_qty = pendingAssetRegisterData.value.quantity_in
  formData.value.bill_date = pendingAssetRegisterData.value.date
  formData.value.bill_number = pendingAssetRegisterData.value.voucher_number
  formData.value.supplier_id = {
    id: pendingAssetRegisterData.value.contact_profile_id,
    name: pendingAssetRegisterData.value.contact_profile_name
  }
}

function onPageReload() {
  loader.value=true

  Promise.all([
    fetchHome().then(res => {
      if (res.data) {
        grandDonation.value = res.data.grant_donation;
        let statusType = res.data.status
        status.value = ["active", "inactive"].map(key => ({
          value:key,
          name: statusType[key],
        }));
      }
    }),
    fetchCostCentreList(getQuery()).then(res => {
      if (res.data) costCentres.value = res.data
    }),
    fetchBusinessList(getQuery()).then(res => {
      if (res.data) businesses.value = res.data
    })

  ]).finally(() => {
    loader.value = false
  })

  formData.value.capitalization_date =  new Date().toISOString().split('T')[0]
  if(route.query.stockRegisterId && route.query.stockRegisterId !== '' && route.query.stockRegisterId !== undefined){
    isPendingAssetRegister.value = true;
    const pendingAssetRegister = fetchSinglePendingAssetRegister(route.query.stockRegisterId, getQuery());
    pendingAssetRegister.then(res => {
      pendingAssetRegisterData.value = res.data;
      setPendingAssetRegisterData();
    });
  }

  if(route.query.assetRegisterId && route.query.assetRegisterId !== '' && route.query.assetRegisterId !== undefined){
    isCreate.value = false;
    const assetData = fetchSingleAssetRegister(route.query.assetRegisterId, getQuery());
    assetData.then(res => {
      assetRegisterEditData.value = res.data;
      setFormData();
    });
  }
}

onMounted(() => {
  onPageReload();
})
</script>